<template>
	<div class="card chat">
		<div class="card-header pr-1">
			<div class="media">
				<div class="align-self-center mr-3 rounded-circle text-center text-white chat-icon">
					<i class="material-icons">group</i>
				</div>
				<div class="media-body" style="line-height: 12px;">
					<h5 class="m-0 font-weight-700">
						{{title}}
					</h5>
					<small class="text-truncate text-muted m-0" v-show="typing">
						{{ user.NOMBRE }} está escribiendo...
					</small>
				</div>
			</div>
		</div>
		<div style="overflow-y: auto;" class="chatBody">
			<infinite-loading 
				@distance="1"
				force-use-infinite-wrapper=".chatBody"
				@infinite="infiniteHandler" 
				spinner="waveDots" 
				ref="infiniteLoading"
				direction="top">
	        	<div slot="no-more" class="text-center">
	            	<span class="badge badge-light shadow p-2">No hay más registros</span>
	          	</div>
	          	<div slot="no-results" class="text-center">
	            	<span class="badge badge-light shadow p-2">No hay registros</span>
	          	</div>
	        </infinite-loading>
			<chat-messages :mensajes="mensajesFiltered" :user="currentUser" ref="chatBody">
			</chat-messages>
			
		</div>
		<chat-form v-on:message="addMessage" v-on:isTyping="isTyping"></chat-form>
	</div>
</template>
<script>
	export default {
		props: ['codigo', 'usuario', 'modulo'],

		data(){
			return {
				title: '',
				description: '',
				mensajes: [],

				page: 0,
				lastID: 0,

				user: '',
				typing: false
			}
		},

		mounted() {
			this.title = this.tipo + ' #' + this.codigoOportunidad
		},

		created(){
			//this.fetchMessages()
			this.load()
			this.listen()
		},

		methods: {
			infiniteHandler($state) {
		        this.page++
		        this.loading = true
		        let url = `api/mensajes/tipo/${this.tipo}/codigo/${this.codigoOportunidad}`

		        axios.get(url, {
		        	params: {
		        		page: this.page,
		        		per_page: 10,
		        		lastID: this.lastID
		        	},
		        })
		        .then(response => {
		            let mensajes = response.data.data
		            if(mensajes.length){
		                this.mensajes.unshift(...mensajes);
		                if (this.page == 1) {
		                	this.lastID = mensajes[0].CODIGO_DETALLE || 0
		                }
		                $state.loaded()
		            }else{
		                $state.complete()
		            }
		        })
		        .catch(error => {
		        	$state.complete()
		        })
		        .then(() => {
		        	var vm = this
					vm.$nextTick(() => {
						if (vm.page == 1) {
							vm.$refs.chatBody.$refs.chatBody.scrollTop = vm.$refs.chatBody.$refs.chatBody.scrollHeight
						}
	                })
		        })
		    },

		    load: function(){
		    	this.page++
		        this.loading = true
		        var vm = this

		        axios.get(`api/mensajes/tipo/${this.tipo}/codigo/${this.codigoOportunidad}`, {
		        	params: {
		        		page: this.page,
		        		per_page: 10,
		        		lastID: this.lastID
		        	},
		        })
		        .then(response => {
		            let mensajes = response.data.data
		            if(mensajes.length){
		                this.mensajes.unshift(...mensajes);
		                if (this.page == 1) {
		                	this.lastID = mensajes[0].CODIGO_DETALLE || 0
		                }
		                vm.$nextTick(() => {
		                	vm.$refs.infiniteLoading.stateChanger.loaded()
		                })
		            }else{
		                vm.$nextTick(() => {
							vm.$refs.infiniteLoading.stateChanger.complete()
		                })
		            }
		        })
		        .catch(error => {
		        	vm.$nextTick(() => {
						vm.$refs.infiniteLoading.stateChanger.complete()
	                })
		        })
		        .then(() => {
		        	var vm = this
					vm.$nextTick(() => {
						if (vm.page == 1) {
							vm.$refs.chatBody.$refs.chatBody.scrollTop = vm.$refs.chatBody.$refs.chatBody.scrollHeight
						}
	                })
		        })
		    },

			listen () {
				let _this = this;

				Echo.private(`chat.${this.tipo}.${this.codigoOportunidad}`)
			        .listen('MessageSent', (data) => {
			        	this.mensajes = this.mensajes.concat(data.message)
			        }).listenForWhisper('typing', (e) => {
			        	this.user = e.user;
		                this.typing = e.typing;

		                setTimeout(function() {
		                    _this.typing = false
		                }, 900);
		            })
		    },

		    isTyping() {
	            var _this = this
	            let channel = Echo.private(`chat.${this.tipo}.${this.codigoOportunidad}`);

	            setTimeout(function() {
	                channel.whisper('typing', {
                    user: _this.currentUser || {},
                    typing: true
                });
	            }, 300);
	        },

			fetchMessages: function(){
				axios.get(`api/mensajes/tipo/${this.tipo}/codigo/${this.codigoOportunidad}?per_page=5`)
					.then(response => {
						this.mensajes = response.data.data
					}).catch(error => {
						console.log(error.response)
					}).then(() => {
						var vm = this
						vm.$nextTick(() => {
							vm.$refs.chatBody.$refs.chatBody.scrollTop = vm.$refs.chatBody.$refs.chatBody.scrollHeight
		                })
					})
			},

			addMessage: function(mensaje){
				this.pushMessage(mensaje)
				var vm = this
				vm.$nextTick(() => {
					vm.$refs.chatBody.$refs.chatBody.scrollTop = vm.$refs.chatBody.$refs.chatBody.scrollHeight
                })

				axios.post(`api/mensajes`, {
					texto: mensaje,
					tipo: this.tipo,
					id_tipo: this.codigoOportunidad
				})
				.then(response => {
					//this.mensajes = this.mensajes.concat(response.data)
				}).catch(error => {
					console.log(error.response)
				})
			},

			pushMessage: function(mensaje){
				this.mensajes.push({
					"CODIGO_DETALLE": 0,
					"CODIGO_MENSAJE":"",
					"TEXTO": mensaje,
					"TEXTO2":null,
					"TEXTO3":null,
					"DOCUMENT_URL":null,
					"FAVORITO":"0",
					"FECHA_CREACION": moment().format('YYYY-MM-DD HH:mm:ss.SSS'),
					"FECHA_ACTUALIZACION":null,
					"CREADO_POR":this.currentUser.CODIGO_USUARIO,
					"ACTUALIZADO_POR":null,
					"CREADO_DESDE":null,
					"ACTUALIZADO_DESDE":null,
					"usuario":{}
				})
			}
		},

		computed: {
			codigoOportunidad: function(){
				return this.codigo
			},

			currentUser: function(){
				return JSON.parse(this.usuario)
			},

			tipo: function(){
				return this.modulo
			},

			mensajesFiltered: function(){
				return this.mensajes.sort((a, b) => (a.FECHA_CREACION > b.FECHA_CREACION) ? 1 : -1)
			}
		},
	}
</script>